import { AnnotationShape } from '@/web-components/import-wizard/typings';
import { checkIsInArea } from './collisionHelper';
import { PrintArea } from '@/web-components/import-wizard-v2/typings/common';

const CORRECTION_FACTOR = 0;

export function alignAnnotationShape(
  rectLineWidth: number,
  activeShape: AnnotationShape,
  printableArea: PrintArea,
  printableAreaRotation: number,
  alignmentType: string,
  actualWidth: number,
  actualHeight: number,
  polygonDetails: any
): void {
  const CORRECTION_FACTOR = 0;

  if (alignmentType === 'align-horizontal-left') {
    if (printableArea.kind === 'Rectangle') {
      if (printableAreaRotation === 0 && activeShape.rotation === 0) {
        activeShape.x = printableArea.x + CORRECTION_FACTOR;
      } else {
        activeShape.x = alignLeftControl(
          rectLineWidth,
          activeShape,
          printableArea,
          printableAreaRotation
        );
      }
    }
    if (printableArea.kind === 'Ellipse') {
      activeShape.x = alignLeftControl(
        rectLineWidth,
        activeShape,
        printableArea,
        printableAreaRotation
      );
    }
  }

  if (alignmentType === 'align-horizontal-right') {
    if (printableArea.kind === 'Rectangle') {
      if (printableAreaRotation === 0 && activeShape.rotation === 0) {
        activeShape.x =
          printableArea.x +
          printableArea.width -
          actualWidth -
          CORRECTION_FACTOR;
      } else {
        activeShape.x = alignRightControl(
          rectLineWidth,
          activeShape,
          actualWidth,
          printableArea,
          printableAreaRotation
        );
      }
    }
    if (printableArea.kind === 'Ellipse') {
      activeShape.x = alignRightControl(
        rectLineWidth,
        activeShape,
        actualWidth,
        printableArea,
        printableAreaRotation
      );
    }
  }

  if (alignmentType === 'align-vertical-top') {
    if (printableArea.kind === 'Rectangle') {
      if (printableAreaRotation === 0 && activeShape.rotation === 0) {
        activeShape.y = printableArea.y + CORRECTION_FACTOR;
      } else {
        activeShape.y = alignTopControl(
          rectLineWidth,
          activeShape,
          printableArea,
          printableAreaRotation
        );
      }
    }
    if (printableArea.kind === 'Ellipse') {
      activeShape.y = alignTopControl(
        rectLineWidth,
        activeShape,
        printableArea,
        printableAreaRotation
      );
    }
  }

  if (alignmentType === 'align-vertical-bottom') {
    if (printableArea.kind === 'Rectangle') {
      if (printableAreaRotation === 0 && activeShape.rotation === 0) {
        activeShape.y =
          printableArea.y +
          printableArea.height -
          actualHeight -
          CORRECTION_FACTOR;
      } else {
        activeShape.y = alignBottomControl(
          rectLineWidth,
          activeShape,
          actualHeight,
          printableArea,
          printableAreaRotation
        );
      }
    }
    if (printableArea.kind === 'Ellipse') {
      activeShape.y = alignBottomControl(
        rectLineWidth,
        activeShape,
        actualHeight,
        printableArea,
        printableAreaRotation
      );
    }
  }

  if (alignmentType === 'align-vertical-center') {
    if (printableArea.kind === 'Rectangle') {
      activeShape.y =
        printableArea.y + printableArea.height / 2 - actualHeight / 2;
    }
    if (printableArea.kind === 'Ellipse') {
      activeShape.y = printableArea.y - actualHeight / 2;
    }
    if (printableArea.kind === 'Polygon') {
      activeShape.y = polygonDetails.y - actualHeight / 2;
    }
  }

  if (alignmentType === 'align-horizontal-center') {
    if (printableArea.kind === 'Rectangle') {
      activeShape.x =
        printableArea.x + printableArea.width / 2 - actualWidth / 2;
    }
    if (printableArea.kind === 'Ellipse') {
      activeShape.x = printableArea.x - actualWidth / 2;
    }
    if (printableArea.kind === 'Polygon') {
      activeShape.x = polygonDetails.x - actualWidth / 2;
    }
  }
}

export function alignLeftControl(
  rectLineWidth: number,
  activeShape: AnnotationShape,
  printableArea: PrintArea,
  printableAreaRotation: number
): number {
  let isInRectangle = false;
  let newX = 0;
  const idx = 2;

  if (printableArea.kind === 'Rectangle') {
    newX = printableArea.x - printableArea.width / 2;
    while (isInRectangle === false) {
      newX = newX + idx;
      isInRectangle = checkIsInArea(
        { ...activeShape, x: newX },
        printableArea,
        printableArea.kind,
        printableAreaRotation,
        rectLineWidth
      );
    }
    return newX;
  } else if (printableArea.kind === 'Ellipse') {
    let isInEllipse = false;
    let idx = 1;

    while (isInEllipse === false) {
      newX = printableArea.x - printableArea.rx + idx * CORRECTION_FACTOR;
      isInEllipse = checkIsInArea(
        { ...activeShape, x: newX },
        printableArea,
        printableArea.kind,
        printableAreaRotation,
        rectLineWidth
      );
      idx = idx + 1;
    }
    return newX;
  }

  return newX;
}

export function alignRightControl(
  rectLineWidth: number,
  activeShape: AnnotationShape,
  actualWidth: number,
  printableArea: PrintArea,
  printableAreaRotation: number
): number {
  let isInRectangle = false;
  const idx = 2;
  let newX = 0;

  if (printableArea.kind === 'Rectangle') {
    newX = printableArea.x + printableArea.width;
    while (isInRectangle === false) {
      newX = newX - idx;
      isInRectangle = checkIsInArea(
        { ...activeShape, x: newX },
        printableArea,
        printableArea.kind,
        printableAreaRotation,
        rectLineWidth
      );
    }
    return newX;
  } else if (printableArea.kind === 'Ellipse') {
    let isInEllipse = false;
    let idx = 1;

    while (isInEllipse === false) {
      newX =
        printableArea.x +
        printableArea.rx * 2 +
        actualWidth -
        idx * CORRECTION_FACTOR;
      isInEllipse = checkIsInArea(
        { ...activeShape, x: newX },
        printableArea,
        printableArea.kind,
        printableAreaRotation,
        rectLineWidth
      );
      idx = idx + 1;
    }
    return newX;
  }

  return newX;
}

export function alignTopControl(
  rectLineWidth: number,
  activeShape: AnnotationShape,
  printableArea: PrintArea,
  printableAreaRotation: number
): number {
  let newY = 0;

  if (printableArea.kind === 'Rectangle') {
    let isInRectangle = false;
    let idx = 1;

    while (isInRectangle === false) {
      newY = printableArea.y + idx * CORRECTION_FACTOR;
      isInRectangle = checkIsInArea(
        {
          ...activeShape,
          y: newY,
        },
        printableArea,
        printableArea.kind,
        printableAreaRotation,
        rectLineWidth
      );
      idx = idx + 1;
    }
    return newY;
  } else if (printableArea.kind === 'Ellipse') {
    let isInEllipse = false;
    let idx = 1;
    while (isInEllipse === false) {
      newY = printableArea.y - printableArea.ry + idx * CORRECTION_FACTOR;
      isInEllipse = checkIsInArea(
        {
          ...activeShape,
          y: newY,
        },
        printableArea,
        printableArea.kind,
        printableAreaRotation,
        rectLineWidth
      );
      idx = idx + 1;
    }
    return newY;
  }

  return newY;
}

export function alignBottomControl(
  rectLineWidth: number,
  activeShape: AnnotationShape,
  actualHeight: number,
  printableArea: PrintArea,
  printableAreaRotation: number
): number {
  let newY = 0;

  if (printableArea.kind === 'Rectangle') {
    let isInRectangle = false;
    let idx = 1;

    while (isInRectangle === false) {
      newY =
        printableArea.y +
        printableArea.height -
        actualHeight -
        idx * CORRECTION_FACTOR;
      isInRectangle = checkIsInArea(
        {
          ...activeShape,
          y: newY,
        },
        printableArea,
        printableArea.kind,
        printableAreaRotation,
        rectLineWidth
      );
      idx = idx + 1;
    }
    return newY;
  } else if (printableArea.kind === 'Ellipse') {
    let isInEllipse = false;
    let idx = 1;
    while (isInEllipse === false) {
      newY =
        printableArea.y +
        printableArea.ry -
        actualHeight -
        idx * CORRECTION_FACTOR;
      isInEllipse = checkIsInArea(
        {
          ...activeShape,
          y: newY,
        },
        printableArea,
        printableArea.kind,
        printableAreaRotation,
        rectLineWidth
      );
      idx = idx + 1;
    }
    return newY;
  }

  return newY;
}
